import { useState } from 'react';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { DetailItem } from '@recargas-dominicanas/core/components';
import { type IPendingTransaction } from '@recargas-dominicanas/core/types';
import { formatCurrency, formatDate, useField } from '@recargas-dominicanas/core/utils';
import { LinkedTransactionSelect } from '../linked-trasaction-select/linked-transaction-select.component';
import { BankAccountStore } from '../../../../store/bankAccountStore';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './link-pending-withdrawal-modal.module.css';

interface Props {
  open: boolean;
  bankAccountId: number;
  pendingTransaction: IPendingTransaction;
  onClose: () => void;
}

export function LinkPendingWithdrawalModal(props: Props) {

  const {
    open,
    bankAccountId,
    pendingTransaction,
    onClose
  } = props;

  const transactionField = useField('');
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState<string>();

  async function handleRegister() {
    
    try {

      setDisabled(true);
      setError(undefined);

      const withdrawalId = transactionField.value ? parseInt(transactionField.value) : undefined;
      await BankAccountApi.linkPendingWithdrawal(bankAccountId, pendingTransaction.id, withdrawalId);
      
      BankAccountStore.fetchById(bankAccountId);
      BankAccountStore.fetchPendingTransactions(bankAccountId, 1, 25);

      handleClose();

    } catch {

      setDisabled(false);
      setError('Error registrando deposito');
    }
  }

  function handleClose() {
    onClose();
    transactionField.clear();
    setDisabled(false);
    setError(undefined);
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Enlazar retiro'
      error={error}
      secondaryButton='Enlazar'
      disabledSecondaryButton={disabled}
      onClose={handleClose}
      onSecondaryClick={handleRegister}>
      <span className={style.selectTitle}>Retiro</span>
      <LinkedTransactionSelect
        className={style.businessSelect}
        icon='payments'
        placeholder='Seleccionar retiro'
        filter='withdrawal'
        bankAccountId={bankAccountId}
        field={transactionField}/>
      <span className={style.transactionTitle}>Transacción</span>
      <DetailItem
        style={style.detailItem}
        title='Monto'
        color='green'
        weight='medium'
        text={formatCurrency(pendingTransaction.balance)}/>      
      <DetailItem
        style={style.detailItem}
        title='Fecha'
        text={formatDate(pendingTransaction.date)}/>
      <DetailItem
        style={style.detailItem}
        title='Fecha de creación'
        text={formatDate(pendingTransaction.creationDate)}/>      
      {pendingTransaction.reference &&
        <DetailItem
          style={style.detailItem}
          title='Referencia'
          text={pendingTransaction.reference}/>      
      }      
      {pendingTransaction.description &&
        <DetailItem
          style={style.detailItem}
          title='Descripción'
          text={pendingTransaction.description}/>      
      }
    </Modal>
  );
}
